// extracted by mini-css-extract-plugin
module.exports = {"main":"forgot-page_main__2oXU1","form":"forgot-page_form__1grfT","nav":"forgot-page_nav__bQ2n-","link":"forgot-page_link__3WXsf"};